import React, { PureComponent } from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { _ } from 'utils/i18n';

import { announceInterruptionStart, announceInterruptionEnd } from 'scripts/frontend/lessons/interruption';

import Modal from './Modal';

const DefaultLessonAbortModalTitle = _('Abort this lesson');

// Time in seconds after which the dialog closes itself again, so that it
// cannot be (mis)used as an unscheduled break.
const AUTO_CLOSE_SECONDS = 10;

class LessonAbortModal extends PureComponent {

    constructor(props) {
        super(props);

        this.node = document.body;

        this.handleChange = this.handleChange.bind(this);
        this.handleInteract = this.handleInteract.bind(this);

        this.state = {
            value: '',
            secondsLeft: AUTO_CLOSE_SECONDS,
        };

        this.autoCloseInterval = null;
    }

    componentDidMount() {
        // This dialog is only mounted while it is open, so mounting/unmounting
        // is what timed blocks need to pause and resume on.
        announceInterruptionStart();

        this.autoCloseInterval = setInterval(() => {
            const { secondsLeft } = this.state;

            if (secondsLeft <= 1) {
                clearInterval(this.autoCloseInterval);
                this.autoCloseInterval = null;
                this.props.onCancel();
            } else {
                this.setState({ secondsLeft: secondsLeft - 1 });
            }
        }, 1000);
    }

    componentWillUnmount() {
        if (this.autoCloseInterval) clearInterval(this.autoCloseInterval);

        announceInterruptionEnd();
    }

    /**
     * Stops the auto-close countdown for good. Called as soon as the
     * participant starts filling in the dialog, so that it cannot close
     * underneath someone who genuinely wants to abort — picking a reason from
     * a native select can easily take longer than the countdown.
     */
    stopAutoClose() {
        if (!this.autoCloseInterval) return;

        clearInterval(this.autoCloseInterval);
        this.autoCloseInterval = null;

        this.setState({ secondsLeft: null });
    }

    render() {
        return createPortal(
            <Modal
                {...this.props}
                {...this.state}
                onChange={this.handleChange}
                onInteract={this.handleInteract}
            />,
            this.node,
        );
    }

    /**
     * Any touch inside the dialog counts as the participant engaging with it:
     * the reason picker can be open for a while before it fires a change.
     */
    handleInteract() {
        return this.stopAutoClose();
    }

    handleChange({ target }) {
        const { value } = target;

        this.stopAutoClose();

        return this.setState({ value });
    }
}

LessonAbortModal.propTypes = {
    title: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
};

LessonAbortModal.defaultProps = {
    title: DefaultLessonAbortModalTitle,
};

const mapStateToProps = ({ abortReasons }) => ({
    abortReasons,
});

export default connect(mapStateToProps)(LessonAbortModal);



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonAbortModal/LessonAbortModal.js